<script setup lang="ts">
/**
 * UI-kit component
 * Category: Dropdown
 * Name: 'AppDropdown'
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=2989-38121
 */
import { computed } from 'vue'

import type { StyleValue } from 'vue'
import type { AppDropdownProps } from '../types/interfaces'

defineOptions({
  name: 'AppDropdown',
})

const props = withDefaults(defineProps<AppDropdownProps>(), {
  maxHeight: undefined,
})

const dropdownStyle = computed<StyleValue | undefined>(() => {
  if (props.maxHeight === undefined) return undefined
  const value = typeof props.maxHeight === 'number'
    ? `${props.maxHeight}px`
    : props.maxHeight
  return { maxHeight: value }
})
</script>

<template>
  <div
    class="app-dropdown"
    :style="dropdownStyle"
  >
    <div class="app-dropdown__list">
      <slot />
    </div>
    <div
      v-if="$slots.footer"
      class="app-dropdown__footer"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<style scoped lang="scss" src="../styles/_app-dropdown.scss" />
